import React from 'react';
import classNames from 'classnames';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { HorizontalDivider } from '../dividers';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { COMMENTS_HEADER, HEADER_DIVIDER, HEADER_SCOPE, HEADER_TITLE, } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { CommentsHeaderRatings } from './comments-header-ratings';
import { UserAuthControl } from '../user-auth-control/user-auth-control';
import { resolveElementAreaClasses } from './comments-header-utils';
import styles from './comments-header.module.scss';
export const CommentsHeader = React.memo(({ commentCount, hideTitle, userAuthControlState, ...props }) => {
    const t = useTranslate();
    const { a11yOptions, headerTitleText } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    const headerCommentCount = commentCount ?? 0;
    const Title = a11yOptions?.headerRank ?? 'span';
    const { titleArea, ratingArea, userAuthArea } = resolveElementAreaClasses({
        isMobile,
        isTitleVisible: !hideTitle,
        isRatingVisible: !props.hideRatings,
        isUserAuthVisible: userAuthControlState.type !== 'HIDDEN',
    });
    return (React.createElement(React.Fragment, null,
        isMobile && (React.createElement(HorizontalDivider, { type: "header", "data-hook": classNames(HEADER_DIVIDER, HEADER_SCOPE) })),
        React.createElement("div", { className: classNames(styles.root, isMobile && styles.isMobile, (hideTitle || props.hideRatings || userAuthControlState.type === 'HIDDEN') &&
                styles.isOneRow), "data-hook": classNames(COMMENTS_HEADER, HEADER_SCOPE) },
            React.createElement("div", { className: styles.innerContainer },
                !hideTitle && (React.createElement(Title, { className: classNames(styles.title, titleArea), "data-hook": HEADER_TITLE }, headerTitleText
                    ? headerTitleText(headerCommentCount)
                    : t('header.all-comments', {
                        count: headerCommentCount,
                    }))),
                userAuthControlState.type !== 'HIDDEN' && (React.createElement("div", { className: classNames(styles.userAuth, userAuthArea) },
                    React.createElement(UserAuthControl, { ...(userAuthControlState.type === 'LOGOUT'
                            ? {
                                state: 'logout',
                                avatarUrl: userAuthControlState.memberAvatarUrl,
                                memberName: userAuthControlState.memberName,
                            }
                            : { state: 'login' }) }))),
                !props.hideRatings && (React.createElement("div", { className: ratingArea },
                    React.createElement(CommentsHeaderRatings, { ...props.ratings })))))));
});
CommentsHeader.displayName = 'CommentsHeader';
//# sourceMappingURL=comments-header.js.map